import React from 'react';
import { Tabs, Tab, Button, styled, Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import {
  borderGrey,
  dimGrey,
  lightBackground1,
  lightBlack,
  lightPurple,
  topBarBg,
} from '../../../mainTheme';

const StyledTab = styled(Tab)({
  textTransform: 'none',
  minWidth: 'auto',
  width: '129px',
  height: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  flexShrink: 0,
  borderRadius: '10px',
  fontSize: '16px',
  letterSpacing: '0.2px',
  lineHeight: '22px',
  fontWeight: 500,
  color: dimGrey,
  '&.Mui-selected': {
    backgroundColor: topBarBg,
    border: `1px solid ${lightPurple}`,
    fontWeight: 700,
    color: lightBlack,
  },
});

interface ButtonConfig {
  show: boolean;
  label: string;
  onClick?: () => void;
}

interface DashboardTabsProps {
  selectedTab?: number;
  onTabChange?: (tab: number) => void;
  buttonConfig?: ButtonConfig;
  isFacilityAdmin?: boolean;
}

export const DashboardTabs: React.FC<DashboardTabsProps> = ({
  selectedTab,
  onTabChange,
  buttonConfig,
  isFacilityAdmin,
}) => (
  <Box
    bgcolor={topBarBg}
    display="flex"
    borderTop={`1px solid ${borderGrey}`}
    justifyContent={
      (selectedTab !== undefined || onTabChange !== undefined) &&
      !isFacilityAdmin
        ? 'space-between'
        : 'flex-end'
    }
    p={1}
    alignItems="center"
    height="68px"
    overflow="auto"
  >
    {(selectedTab !== undefined || onTabChange !== undefined) &&
      !isFacilityAdmin && (
        <Box
          bgcolor={lightBackground1}
          borderRadius="10px"
          p={2}
          height="40px"
          display="flex"
          alignItems="center"
        >
          <Tabs
            value={selectedTab}
            onChange={(_, value) => onTabChange?.(value)}
            sx={{
              '& .MuiTabs-flexContainer': {
                gap: 1,
                height: '30px',
              },
              '& .MuiTabs-indicator': { display: 'none' },
              minHeight: 'unset',
              '& .MuiTab-root': {
                minHeight: '30px',
                paddingTop: '13px',
                paddingBottom: '13px',
              },
            }}
          >
            <StyledTab label="View all" />
            <StyledTab label="Facilities" />
            <StyledTab label="Consumers" />
          </Tabs>
        </Box>
      )}

    {buttonConfig?.show && (
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        color="secondary"
        onClick={buttonConfig.onClick}
        sx={{
          display: 'inline-flex',
          height: '40px',
          padding: '12px 24px',
          alignItems: 'center',
          gap: '4px',
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '18px',
          letterSpacing: '0.2px',
        }}
      >
        {buttonConfig.label}
      </Button>
    )}
  </Box>
);
